import { useEffect, useRef, useState } from 'react'
import { api, ErrorDeApi } from '../servicios/api'
import { nombreDePeriodo } from '../periodos'

/**
 * Descarga el paquete de declaraciones del mes (RF-1210): los papeles de IVA e ISR vigentes y la
 * cédula de conciliación en un ZIP. El LEEME del ZIP dice qué trae y qué falta y por qué, así que
 * el botón no se deshabilita aunque falte un papel sellado: un paquete incompleto se explica solo.
 * Va en las tres pantallas del mes (IVA, ISR y conciliación) con el periodo que cada una muestra.
 */
export function PaqueteDeDeclaraciones({ clienteId, anio, mes }: { clienteId: string; anio: number; mes: number }) {
  const [generando, setGenerando] = useState(false)
  const [error, setError] = useState('')

  // El error de una descarga de otro mes ya no es de esta pantalla.
  const periodoVigente = useRef(`${clienteId}-${anio}-${mes}`)

  useEffect(() => {
    periodoVigente.current = `${clienteId}-${anio}-${mes}`
    setError('')
  }, [clienteId, anio, mes])

  async function descargar() {
    const periodo = periodoVigente.current
    setGenerando(true)
    setError('')
    try {
      await api.descargarPaqueteDeDeclaraciones(clienteId, anio, mes)
    } catch (e) {
      if (periodoVigente.current === periodo)
        setError(e instanceof ErrorDeApi ? e.message : 'No se pudo generar el paquete de declaraciones.')
    } finally {
      setGenerando(false)
    }
  }

  return (
    <p className="filtros">
      <button type="button" className="secundario" disabled={generando} onClick={() => void descargar()}>
        {generando ? 'Generando…' : `Paquete de declaraciones de ${nombreDePeriodo(anio, mes)}`}
      </button>
      <span className="sutil">Los papeles sellados vigentes y la cédula de conciliación en un ZIP, con lo que falta y por qué.</span>
      {error && <span className="error" role="alert">{error}</span>}
    </p>
  )
}
